import { useEffect, useState } from 'react';
import { Storage } from 'aws-amplify';
import PropTypes from 'prop-types';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';
import { ZoomIn } from '@mui/icons-material';

export default function AssetPhotoListProfile({ asset }) {
  const [imageUrl, setImageUrl] = useState();
  const [openDialog, setOpenDialog] = useState();

  useEffect(() => {
    (async () => {
      try {
        const signedURL = await Storage.get(asset?.s3_object_key); // get key from Storage.list
        setImageUrl(signedURL);
      } catch (error) {
        console.log('Error getting asset ', error);
      }
    })();
  }, []);

  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <ImageListItem key={asset.id}>
        <img src={`${imageUrl}`} srcSet={`${imageUrl}`} alt={asset.type_of_asset} />
        <ImageListItemBar
          subtitle={asset.type_of_asset}
          actionIcon={
            <IconButton sx={{ color: 'rgba(255, 255, 255, 0.54)' }} aria-label="info about">
              <ZoomIn color="success" onClick={handleClickOpen} />
            </IconButton>
          }
        />
      </ImageListItem>
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogContent>
          <img src={`${imageUrl}`} srcSet={`${imageUrl}`} alt={asset.type_of_asset} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

AssetPhotoListProfile.propTypes = {
  asset: PropTypes.instanceOf(Object).isRequired,
};
